import React from 'react';
import { connect } from 'react-redux';
import moment from 'moment';
import Utils from 'helpers/utils.js';
import { Button } from '@kambria/kambria-lego';
import { getSessionHistory } from 'redux/actions/mvp/session-history.action';
import { getOrderHistory } from 'redux/actions/order.action';
import enums from 'helpers/const';

const INITAL_LIMIT = 5;
const PAYMENT_METHODS = Utils.setValueLikeKeyObject(enums.PAYMENT_METHODS);

class SessionHistory extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      sessionHistory: [],
      page: 1,
    };
  }

  async componentDidMount() {
    const { getOrderHistory, getSessionHistory } = this.props;
    getOrderHistory(INITAL_LIMIT, 1);
    const response = await getSessionHistory(INITAL_LIMIT, 1);
    if (response.success && Array.isArray(response.data.data)) {
      this.setState({ sessionHistory: response.data.data });
    } else {
      this.setState({ sessionHistory: [] });
    }
    // console.log('sessionHistory', response.data.data);
  }

  onLoadMore = async () => {
    const { getSessionHistory } = this.props;
    const { page, sessionHistory } = this.state;
    const newPage = page + 1;
    const response = await getSessionHistory(INITAL_LIMIT, newPage);
    if (response.success && Array.isArray(response.data.data)) {
      this.setState({
        sessionHistory: [...sessionHistory, ...response.data.data],
        page: newPage,
      });
    }
  };

  btnLoadMore = (
    <Button type="gray" size="sm" onClick={this.onLoadMore}>
      Load more
    </Button>
  );

  renderLoadMoreBtn = () => {
    const { sessionHistory } = this.state;
    if (sessionHistory.length >= INITAL_LIMIT) {
      return this.btnLoadMore;
    }
    return null;
  };

  render() {
    const { order } = this.props;
    const { sessionHistory } = this.state;

    return (
      <div className="table-responsive">
        <h3>Session History</h3>
        <table className="table">
          <thead>
            <tr>
              <th className="text-left pr-2" style={{ whiteSpace: 'normal', maxWidth: '150px', wordWrap: 'break-word' }}>Title</th>
              <th className="text-left pr-2" style={{ whiteSpace: 'normal' }}>Status</th>
              <th className="text-left pr-2" style={{ whiteSpace: 'normal' }}>Payment</th>
              <th className="text-left pr-2" style={{ whiteSpace: 'normal' }}>Start</th>
              <th className="text-left pr-2" style={{ whiteSpace: 'normal' }}>End</th>
            </tr>
          </thead>
          <tbody> 
            {sessionHistory.map((item, index) => (
              <tr key={index}>  
                <td className="pr-2" style={{ color: '#97a4ad', fontSize: '13px', whiteSpace: 'normal', maxWidth: '150px', wordWrap: 'break-word' }}>
                  {item.sessionUser.dataSession.title}
                </td>
                <td className="pr-2" style={{ color: '#97a4ad', fontSize: '13px', whiteSpace: 'nowrap' }}>
                  {item.sessionUser.status}
                </td>
                <td className="pr-2" style={{ color: '#97a4ad', fontSize: '13px', whiteSpace: 'nowrap' }}>
                  {item.sessionUser.paid===true ? "Paid" : "Not Paid"}
                </td>
                <td className="pr-2" style={{ color: '#97a4ad', fontSize: '13px', whiteSpace: 'nowrap' }}>
                  {item.sessionUser.startTime ? moment(item.sessionUser.startTime).format('HH:mm DD/MM/YYYY') : 'N/A'}
                </td>
                <td className="pr-2" style={{ color: '#97a4ad', fontSize: '13px', whiteSpace: 'nowrap' }}>
                  {item.sessionUser.endTime ? moment(item.sessionUser.endTime).format('HH:mm DD/MM/YYYY') : 'N/A'}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
        {this.renderLoadMoreBtn()}
      </div>
    );
  }
}

const mapStateToProps = ({ order }) => ({
  order,
});

const mapDispatchToProps = {
  getOrderHistory,
  getSessionHistory,
};

export default connect(mapStateToProps, mapDispatchToProps)(SessionHistory);